import { createApp } from "vue";
import PxDSM from "@aeroglobe/proxima-design-system";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/main.css";
import "./core/styles/index.css";
import HotjarPlugin from "./core/plugins/hotjar";
import VueECharts from "vue-echarts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart, PieChart } from "echarts/charts";
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
]);

const app = createApp(App);

app.use(router);
app.use(store);
app.use(PxDSM);
app.use(HotjarPlugin);
app.component("VChart", VueECharts);

const loadGoogleMaps = () =>
  import("@fawmi/vue-google-maps").then((module) => {
    app.use(module.default, {
      load: {
        key: import.meta.env.VITE_APP_GOOGLE_MAP_API_KEY,
      },
    });
  });

app.config.globalProperties.$loadGoogleMaps = loadGoogleMaps;

app.mount("#app");
